import React from 'react'
import { withRouter } from 'react-router-dom'
import base64url from 'base64url'
import { Container, Header } from '../../components_renew/Layout'
import btn_recharge from '../../assets/img/tutorial-banner-btn.png'
import { postMessage } from '../../utils'

@withRouter
class Frame extends React.PureComponent {
  constructor (props) {
    super(props)
    const { search: SearchParams } = props.location
    const urlParams = new URLSearchParams(SearchParams)
    this.withHeader = urlParams.get('withHeader')
    this.btnType = urlParams.get('btn')
    switch (this.btnType) {
      case 'recharge':
        this.btn = btn_recharge
        break
      default:
    }
  }

  componentDidMount () {
    let { title } = this.props.match.params
    if (title) {
      document.title = title
    }
  }

  render () {
    const { src, title } = this.props.match.params
    return <Container>
      {this.withHeader ? <Header>{title}</Header> : null}
      <div className={'overflow-y-auto'}>
        <div className={'relative'}>
          <img className={'w-full block'} src={base64url.decode(src)} alt=""/>
          {
            this.btn
              ? <div className={'absolute bottom-10 w-full'} onClick={this.onBtnClick}>
                <img className={'m-auto block'} src={this.btn} alt=""/>
              </div>
              : null
          }
        </div>
      </div>
    </Container>
  }

  onBtnClick = () => {
    console.log(this.btnType)
    postMessage({ type: this.btnType })
  }
}

export default Frame
